import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { PaymentService } from 'src/app/pages/payment/simpayx-payment.service';
import { LOCAL_STORAGE } from 'src/app/shared/constants/local-storage.constants';
import { CustomerInput } from 'src/app/shared/models/customer.model';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { StorageService } from 'src/app/shared/services/storage.service';

@Component({
  selector: 'simpayx-manage-cards',
  templateUrl: './manage-cards.component.html',
  styleUrls: ['./manage-cards.component.scss'],
})
export class ManageCardsComponent implements OnInit {
  savedCards: any;
  customerServiceSubscription!: Subscription;
  customerDetails!: CustomerInput;
  isLoading: boolean = true;
  paymentSubscription!: Subscription;
  backHref: string;

  constructor(
    private paymentService: PaymentService,
    private alertController: AlertController,
    private customerService: CustomerService,
    private router: Router,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    this.getCustomerDetails();
    this.getBusinessIdMerchantIdFromLocal();
  }

  getCardImage(card: any) {
    return `../assets/card-icons/Dark/${card}.png`;
  }

  getCustomerDetails() {
    this.customerServiceSubscription = this.customerService
      .getCustomerAsObservable()
      .subscribe((result: CustomerInput) => {
        console.log(result);
        if (result !== null) {
          console.log(result);
          this.customerDetails = result;
          this.getPaymentMethods();
        }
      });
  }

  getPaymentMethods() {
    if (this.customerDetails.paymentCustomerId !== null) {
    this.storageService.removeValue(LOCAL_STORAGE.SAVED_CARDS);
    this.paymentSubscription = this.paymentService
      .getPaymentMethodList(this.customerDetails.paymentCustomerId)
      .subscribe((response: any) => {
        this.isLoading = false;
        this.savedCards = response.data.GetPaymentMethods;
        this.storageService.setLocalStorageData(
          LOCAL_STORAGE.SAVED_CARDS,
          this.savedCards 
        );
      });
    }
    else{
      this.isLoading = false;
    }
  }

  async removeCards(card: any) {
    const alert = await this.alertController.create({
      header: "Alert",
      message: "Are you sure you want to remove this card?",
      backdropDismiss: false,
      mode: "ios",
      buttons: [
        {
          text: "Yes",
          handler: () => {
            this.paymentService
              .deleteCards(card.cardId)
              .subscribe((response: any) => {
                console.log(response.data.DeletePaymentMethod);
                this.getPaymentMethods();
              });
          },
        },
        {
          text: "Cancel",
          role: "cancel",
          handler: () => {
            console.log("cancel Okay");
          },
        },
      ],
    });
    await alert.present();

    const { role } = await alert.onDidDismiss();
  }

  getBusinessIdMerchantIdFromLocal() {
    const businessId = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    ).businessId;
    const merchantId = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    ).merchantId;
    const baseUrl = 'simpayx/logistic';
    const queryParams = `merchantId=${merchantId}&businessId=${businessId}`;
    this.backHref = `${baseUrl}?${queryParams}`;
  }

  ngOnDestroy() {
    if (this.paymentSubscription) {
      this.paymentSubscription.unsubscribe();
    }
    if (this.customerServiceSubscription) {
      this.customerServiceSubscription.unsubscribe();
    }
  }
}
